export const examAdminAuditLogs = {
  titleAll: "監査ログ",
  titleLogin: "ログインログ",
  titleOperation: "操作ログ",
  subtitleAll: "主要な更新操作を対象にした監査証跡を記録します",
  subtitleLogin: "認証モジュールのログのみを表示します",
  subtitleOperation: "認証以外の操作ログを表示します",
  drawer: {
    title: "ログ #{id}",
    detailJson: "detail_json",
    technicalFields: "技術項目（障害対応）",
  },
  columns: {
    id: "ID",
    time: "時刻",
    actor: "操作ユーザー",
    loginResult: "ログイン結果",
    loginAudience: "ログイン対象",
    loginIp: "ログイン IP",
    loginResolution: "解像度",
    loginUa: "ブラウザー UA",
    loginOs: "OS",
    loginBrowser: "ブラウザー",
    loginDpr: "ピクセル比",
    loginTimezone: "タイムゾーン",
    loginLanguage: "言語",
    failureReason: "失敗理由",
    operationResult: "結果",
    operationIp: "操作 IP",
    operationUa: "ブラウザー UA",
    xForwardedFor: "転送 IP チェーン",
    xRealIp: "実 IP",
    referer: "参照元",
    origin: "オリジン",
    module: "モジュール",
    action: "操作",
    resource: "リソース",
    relation: "関連",
    objectType: "対象種別",
    objectIdentifier: "対象識別子",
    summary: "要約",
  },
  audience: {
    staff: "試験運営スタッフ",
    candidate: "受験者",
  },
  stats: {
    total: "全 {count} 件",
    moduleCount: "モジュール数",
    resultGroup: "結果",
    audienceGroup: "ログイン主体",
    summaryUnavailable: "監査ログの凡例件数の読み込みに失敗したため、件数を表示できません",
  },
  result: {
    success: "成功",
    failed: "失敗",
    unknown: "不明",
  },
  actions: {
    updateUserPreferences: "ユーザー設定を更新",
  },
  meta: {
    os: {
      windows: "Windows",
      macos: "macOS",
      android: "Android",
      ios: "iOS",
      linux: "Linux",
      other: "その他",
    },
    browser: {
      edge: "Edge",
      chrome: "Chrome",
      firefox: "Firefox",
      safari: "Safari",
      other: "その他ブラウザー",
    },
  },
  filters: {
    actorUserId: "操作ユーザー ID",
    module: "モジュール",
    action: "操作",
    resourceType: "リソース種別",
    resourceId: "リソース ID",
    examId: "試験 ID",
    attemptId: "受験 ID",
    limit: "件数",
  },
};
